import { Tournament } from '../models';
import { TournamentRepository } from '../repositories';
import { ModerateContentUseCase } from './ModerateContentUseCase';

export class UpdateTournamentUseCase {
  constructor(
    private tournamentRepository: TournamentRepository,
    private moderateContent: ModerateContentUseCase,
  ) {}

  async execute(
    tournamentId: string,
    params: {
      name?: string;
      description?: string;
    },
    userId?: string
  ): Promise<Tournament> {
    // Get tournament to check status
    const tournament = await this.tournamentRepository.getById(tournamentId);
    if (!tournament) {
      throw new Error('Tournament not found');
    }

    // Only allow editing if tournament is in setup
    if (tournament.status !== 'setup') {
      throw new Error('Cannot edit tournament after it has started');
    }

    // Validate name if provided
    if (params.name !== undefined && !params.name.trim()) {
      throw new Error('Tournament name cannot be empty');
    }

    // Moderate content before writing
    const moderationUserId = userId || tournament.userId;
    if (params.name) {
      await this.moderateContent.execute(params.name, 'tournament_name', moderationUserId);
    }
    if (params.description) {
      await this.moderateContent.execute(params.description, 'tournament_description', moderationUserId);
    }

    // Update tournament
    const updatedTournament = await this.tournamentRepository.update(tournamentId, {
      name: params.name?.trim(),
      description: params.description?.trim(),
    });

    return updatedTournament;
  }
}